/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A place for VDK Web CTV UI components and utilities (@accedo/vdkweb-tv-ui) 7.1.0
* 
*******************************************************************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["x", "y", "head", "tail", "style"],
  _excluded2 = ["className", "ds", "data", "buffer", "headPadding", "tailPadding", "headPeek", "tailPeek", "alignGrid", "vertical", "horizontal", "loop", "repeat", "spacing", "crossOffset", "width", "height", "nav", "itemWidth", "itemHeight", "initialState", "keyProperty", "animated", "DisplayComponent", "displayComponentProps", "theme", "onClick", "onFocus", "onChange", "style", "dir", "showDots", "arrows", "arrowsStyles", "arrowsTheme", "arrowsIcons"];
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable require-await */
import React from 'react';
import PropTypes from 'prop-types';
import { focusManager } from '@accedo/vdkweb-navigation';
import classnames from 'classnames';
import FocusDiv from '../FocusDiv/FocusDiv';
import FocusDivButton from '../FocusDivButton/FocusDivButton';
import { ArrowUpIcon as DefaultArrowUpIcon, ArrowDownIcon as DefaultArrowDownIcon, ArrowLeftIcon as DefaultArrowLeftIcon, ArrowRightIcon as DefaultArrowRightIcon } from './IconButton';
import componentTheme from './contentGrid.scss';
import { calculateSpanCount, getItemNavId, getStructuredItems, increaseInstance, calculateItems, getTotalSlides, getPageToRequest, calculateLimit } from './utils';
import isRTL from '../utils/isRTL';
var BUFFER = 1;
var DEFAULT_PAGE_SIZE = 20;
var DEFAULT_LIMIT = 10;
var renderItems = function renderItems(_ref) {
  var rtl = _ref.rtl,
    dir = _ref.dir,
    DisplayComponent = _ref.DisplayComponent,
    onClick = _ref.onClick,
    _onFocus = _ref.onFocus,
    items = _ref.items,
    displayComponentProps = _ref.displayComponentProps,
    itemWidth = _ref.itemWidth,
    itemHeight = _ref.itemHeight;
  return items.map(function (item) {
    var x = item.x,
      y = item.y,
      head = item.head,
      tail = item.tail,
      style = item.style,
      props = _objectWithoutProperties(item, _excluded);
    if (onClick) {
      props.onClick = function () {
        return onClick(item);
      };
    }
    var carouselItemPosition = {
      top: item.y,
      position: 'absolute'
    };
    if (rtl) {
      carouselItemPosition.right = item.x;
    } else {
      carouselItemPosition.left = item.x;
    }
    return /*#__PURE__*/React.createElement("div", {
      key: item.nav.id,
      style: carouselItemPosition
    }, /*#__PURE__*/React.createElement(DisplayComponent, _extends({}, displayComponentProps, props, {
      dir: dir,
      height: itemHeight,
      onFocus: function onFocus() {
        return _onFocus(item);
      },
      width: itemWidth
    })));
  });
};

// eslint-disable-next-line valid-jsdoc
/**
 * Component to display data items as Grid or Carousel focused on performance.
 * Can be horizontal or vertical, with
 * arbitrary number of rows and columns.
 * The size of the grid is used to
 * calculate how many items are
 * rendered.
 * items are expected to all have the
 * same fixed size. variable item size
 * in the same grid is not supported.
 * See property comments below for more
 * details.
 */
var FocusContentGrid = function FocusContentGrid(_ref2, ref) {
  var _state$items7, _classnames, _state$items8, _state$items9;
  var className = _ref2.className,
    ds = _ref2.ds,
    data = _ref2.data,
    _ref2$buffer = _ref2.buffer,
    buffer = _ref2$buffer === void 0 ? BUFFER : _ref2$buffer,
    _ref2$headPadding = _ref2.headPadding,
    headPadding = _ref2$headPadding === void 0 ? 0 : _ref2$headPadding,
    _ref2$tailPadding = _ref2.tailPadding,
    tailPaddingProp = _ref2$tailPadding === void 0 ? 0 : _ref2$tailPadding,
    _ref2$headPeek = _ref2.headPeek,
    headPeekProp = _ref2$headPeek === void 0 ? 0 : _ref2$headPeek,
    _ref2$tailPeek = _ref2.tailPeek,
    tailPeekProp = _ref2$tailPeek === void 0 ? 0 : _ref2$tailPeek,
    _ref2$alignGrid = _ref2.alignGrid,
    alignGrid = _ref2$alignGrid === void 0 ? true : _ref2$alignGrid,
    _ref2$vertical = _ref2.vertical,
    verticalProp = _ref2$vertical === void 0 ? false : _ref2$vertical,
    _ref2$horizontal = _ref2.horizontal,
    horizontal = _ref2$horizontal === void 0 ? false : _ref2$horizontal,
    _ref2$loop = _ref2.loop,
    loopProp = _ref2$loop === void 0 ? false : _ref2$loop,
    _ref2$repeat = _ref2.repeat,
    repeat = _ref2$repeat === void 0 ? false : _ref2$repeat,
    _ref2$spacing = _ref2.spacing,
    spacing = _ref2$spacing === void 0 ? 0 : _ref2$spacing,
    _ref2$crossOffset = _ref2.crossOffset,
    crossOffset = _ref2$crossOffset === void 0 ? 0 : _ref2$crossOffset,
    width = _ref2.width,
    carouselHeight = _ref2.height,
    parentNav = _ref2.nav,
    itemWidth = _ref2.itemWidth,
    itemHeight = _ref2.itemHeight,
    _ref2$initialState = _ref2.initialState,
    initialState = _ref2$initialState === void 0 ? {} : _ref2$initialState,
    keyProperty = _ref2.keyProperty,
    _ref2$animated = _ref2.animated,
    animatedProp = _ref2$animated === void 0 ? false : _ref2$animated,
    DisplayComponent = _ref2.DisplayComponent,
    displayComponentProps = _ref2.displayComponentProps,
    theme = _ref2.theme,
    onClick = _ref2.onClick,
    onFocus = _ref2.onFocus,
    onChange = _ref2.onChange,
    style = _ref2.style,
    _ref2$dir = _ref2.dir,
    dir = _ref2$dir === void 0 ? 'ltr' : _ref2$dir,
    _ref2$showDots = _ref2.showDots,
    showDots = _ref2$showDots === void 0 ? false : _ref2$showDots,
    _ref2$arrows = _ref2.arrows,
    arrows = _ref2$arrows === void 0 ? false : _ref2$arrows,
    arrowsStyles = _ref2.arrowsStyles,
    arrowsTheme = _ref2.arrowsTheme,
    arrowsIcons = _ref2.arrowsIcons,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var pageSize = React.useMemo(function () {
    return (ds === null || ds === void 0 ? void 0 : ds.pageSize) || DEFAULT_PAGE_SIZE;
  }, [ds]);
  var fetchItemLimit = React.useMemo(function () {
    return (ds === null || ds === void 0 ? void 0 : ds.fetchItemLimit) || DEFAULT_LIMIT;
  }, [ds]);
  /**
   * vertical orientation is default
   */
  var vertical = horizontal === verticalProp || horizontal === false;

  // can only loop if not repeating
  var loop = loopProp && !repeat;
  var rtl = isRTL(dir);
  var height = carouselHeight || itemHeight;

  /**
   * calculate padding and peek when alignGrid flag is active.
   * headPadding prop is always used because it will define
   * where items are placed when grid is at head position.
   * headPeek will be same as headPadding so items align in
   * same place when grid is shifted.
   * tailPadding and tailPeek will use same value, calculated
   * to be at least as large as tailPadding prop, but adjusted
   * so items are always aligned when items are shifted into
   * view.
   */
  var headPeek = React.useMemo(function () {
    if (alignGrid) {
      return headPadding;
    }
    return headPeekProp;
  }, [alignGrid, headPeekProp, headPadding]);
  var tailPadding = React.useMemo(function () {
    if (alignGrid) {
      var itemSize = vertical ? itemHeight : itemWidth;
      var lengthSize = vertical ? height : width;
      var calculated = lengthSize - headPadding - Math.floor((lengthSize - headPadding) / (itemSize + spacing)) * (itemSize + spacing) + spacing;
      while (calculated < tailPaddingProp) {
        calculated += itemSize + spacing;
      }

      // use original value if calculated is large enough that a single item will not fit in view
      if (lengthSize - headPadding - calculated < itemSize) {
        return tailPaddingProp;
      }
      return calculated;
    }
    return tailPaddingProp;
  }, [tailPaddingProp, height, alignGrid, headPadding, itemHeight, spacing, vertical, width, itemWidth]);
  var tailPeek = React.useMemo(function () {
    if (alignGrid) {
      return tailPadding;
    }
    return tailPeekProp;
  }, [tailPadding, alignGrid, tailPeekProp]);

  /**
   * Main state
   * values are combined into one object to avoid excessive rerender when changing multiple state values
   */
  var initialPosition = (initialState === null || initialState === void 0 ? void 0 : initialState.position) === undefined ? headPadding : initialState.position;
  var _React$useState = React.useState({
      // Whether grid has been focused since last time data/ds props changed
      focused: false,
      // position of shift panel, used to render shift panel in correct position and to calculate what items should render
      position: initialPosition,
      // Whether grid is in head or tail edge position
      edge: {
        head: initialPosition === headPadding,
        tail: false
      },
      // spread is used to increase the area to render items in while shifting, so there are always visible items when shift panel moves
      spread: [initialPosition, initialPosition],
      // items to render at the current position
      items: undefined,
      id: 0,
      forwardFocus: undefined,
      dots: []
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    state = _React$useState2[0],
    setState = _React$useState2[1];

  /**
   * references to state values are used to allow
   * accessing correct value inside hooks without
   * adding more dependency to the hook which will
   * trigger the hook more often than intended.
   */
  var stateRef = React.useRef();
  stateRef.current = state;
  var lastState = React.useRef({});

  // Reference to current position so value can be accessed inside hooks without using position as a dependency
  var positionRef = React.useRef();
  positionRef.current = state.position;

  // reference to shift panel element
  var shiftPanel = React.useRef();

  /**
   * used to align update of position and spread so
   * they are synched.
   * returns object to be spread when updating state.
   */
  var updatePosition = React.useCallback(function (stateValue, newPosition, reset) {
    var spreadValue = stateValue.spread;
    // smallest spread is always used when not animated

    var resetSpread = reset === true || animatedProp !== true;
    if (!resetSpread && shiftPanel.current && newPosition !== undefined) {
      var MAX_SPREAD_MULTIPLIER = 3;
      var MAX_SPREAD = (vertical ? height : width) * MAX_SPREAD_MULTIPLIER;
      var newSpreadMin = Math.min(newPosition, spreadValue[0], spreadValue[1]);
      var newSpreadMax = Math.max(newPosition, spreadValue[0], spreadValue[1]);

      // limit how much can be rendered at one time. especially important when looping, else all items will be rendered.
      if (Math.abs(newSpreadMax - newSpreadMin) > MAX_SPREAD) {
        /**
         * read from dom to get current position of shift panel.
         * accessing dom value will trigger reflow and repaint
         * and this can affect performance, so access is limited
         * here only when needed, and value is used to improve
         * performance by avoiding excessive render.
         * rendered panel position is defined in vw values, and
         * getBoundingClientRect will get the pixel value, so it
         * needs to be unscaled to get a 1080 based pixel value
         * that is later used to calculate vw value again.
         */
        var panelPosition = shiftPanel.current.getBoundingClientRect()[vertical ? 'top' : 'left'];

        // grid will move forward by shifting panel backward
        if (panelPosition > newPosition) {
          newSpreadMax = panelPosition;
        }
        // grid will move backward by shifting panel forward
        else if (panelPosition < newPosition) {
          newSpreadMin = panelPosition;
        }

        // default to reset if spread is still too large
        resetSpread = Math.abs(newSpreadMax - newSpreadMin) > MAX_SPREAD;
      }
      if (!resetSpread) {
        spreadValue = [newSpreadMin, newSpreadMax];
      }
    }
    if (resetSpread) {
      spreadValue = [newPosition === undefined ? stateValue.position : newPosition, newPosition === undefined ? stateValue.position : newPosition];
    }
    return {
      position: newPosition === undefined ? stateValue.position : newPosition,
      // spread needs to be updated together with position
      spread: spreadValue
    };
  }, [animatedProp, vertical, width, height]);
  var onItemClick = React.useCallback(function (item) {
    onClick === null || onClick === void 0 ? void 0 : onClick({
      data: item.data,
      state: {
        position: positionRef.current,
        id: item.data[keyProperty]
      }
    });
  }, [onClick, keyProperty]);

  /**
   * track what to focus after looping
   * 0 is no pending refocus.
   * 1 will focus first item after looping at tail
   * -1 will focus last item after looping at head
   */
  var reFocus = React.useRef(0);

  /**
   * setup internal nav object used to trigger looping at edges
   */
  var internalNav = React.useMemo(function () {
    var internal;
    if (loop) {
      internal = {};
      var spanCount = calculateSpanCount(vertical ? width : height, vertical ? itemWidth : itemHeight, spacing);
      var lengthSize = vertical ? height : width;
      var itemSizeWithSpacing = (vertical ? itemHeight : itemWidth) + spacing;
      var triggerShift = function triggerShift(count) {
        var pos = lengthSize + spacing - Math.floor(count / spanCount) * itemSizeWithSpacing - tailPadding;

        // only loop when shift is needed

        if (reFocus.current === 0 && pos < positionRef.current && Math.floor(count / spanCount) * itemSizeWithSpacing > lengthSize - tailPadding - headPadding + spacing) {
          var _stateRef$current$ite, _stateRef$current$ite2;
          /**
           * calling changeFocus twice to reset both currentFocus
           * and lastFocus and prevent any further internal focus
           * until the refocus is triggered.
           */
          focusManager.changeFocus('');
          focusManager.changeFocus('');

          // direct refocus when item is already rendered
          if ((_stateRef$current$ite = stateRef.current.items) !== null && _stateRef$current$ite !== void 0 && (_stateRef$current$ite2 = _stateRef$current$ite[stateRef.current.items.length - 1]) !== null && _stateRef$current$ite2 !== void 0 && _stateRef$current$ite2.tail) {
            focusManager.changeFocus(stateRef.current.items[stateRef.current.items.length - 1].nav.id);
          }
          // need to render item to refocus
          else {
            reFocus.current = -1;
          }
          setState(function (value) {
            return _objectSpread(_objectSpread(_objectSpread({}, value), updatePosition(value, pos)), {}, {
              edge: {
                head: false,
                tail: true
              }
            });
          });
        }
      };
      var nextHead = function nextHead() {
        var triggerPosition = positionRef.current;
        if (ds) {
          ds.getTotalNumber().then(function (count) {
            // position has not changed during asynchronous operation
            if (triggerPosition === positionRef.current) {
              triggerShift(count);
            }
          });
        } else if (data) {
          triggerShift(data.length);
        }
        return true;
      };
      var nextTail = function nextTail() {
        // only loop when shift is needed
        if (positionRef.current < headPadding && reFocus.current === 0) {
          var _stateRef$current$ite3, _stateRef$current$ite4;
          /**
           * calling changeFocus twice to reset both currentFocus
           * and lastFocus and prevent any further internal focus
           * until the refocus is triggered.
           */
          focusManager.changeFocus('');
          focusManager.changeFocus('');

          // direct refocus when item is already rendered
          if ((_stateRef$current$ite3 = stateRef.current.items) !== null && _stateRef$current$ite3 !== void 0 && (_stateRef$current$ite4 = _stateRef$current$ite3[0]) !== null && _stateRef$current$ite4 !== void 0 && _stateRef$current$ite4.head) {
            focusManager.changeFocus(stateRef.current.items[0].nav.id);
          }
          // need to render item to refocus
          else {
            reFocus.current = 1;
            // will trigger shift and data load if needed
          }

          setState(function (value) {
            return _objectSpread(_objectSpread(_objectSpread({}, value), updatePosition(value, headPadding)), {}, {
              edge: {
                head: true,
                tail: false
              }
            });
          });
        }
        return true;
      };
      if (vertical) {
        internal.nextup = nextHead;
        internal.nextdown = nextTail;
      } else {
        internal.nextleft = nextHead;
        internal.nextright = nextTail;
      }
    }
    return internal;
  }, [ds, rtl, data, updatePosition, loop, vertical, width, height, itemWidth, itemHeight, spacing, tailPadding, headPadding]);
  var internalDS = React.useMemo(function () {
    var items = [];
    var totalItems = 0;
    var requestedPage = 0;
    var maxReturnedPage = 0;
    var latestInitialIndex = 0;
    var latestLastIndex = 0;
    var addItems = function addItems(newItems) {
      var itemsToRemove = 0;
      var itemsToAdd = newItems.data || [];
      items.splice.apply(items, [items.length, itemsToRemove].concat(_toConsumableArray(itemsToAdd)));
    };
    var getTotalItems = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!totalItems) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", Promise.resolve(totalItems));
            case 2:
              return _context2.abrupt("return", ds.getData(0, 1).then( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(result) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        totalItems = result.total;
                        return _context.abrupt("return", totalItems);
                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2) {
                  return _ref4.apply(this, arguments);
                };
              }()));
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function getTotalItems() {
        return _ref3.apply(this, arguments);
      };
    }();
    var getData = function getData(initialIndexParam, lastIndex) {
      latestInitialIndex = initialIndexParam;
      latestLastIndex = lastIndex;
      if (totalItems <= items.length && totalItems > 0) {
        // We have fetched all the data, just return the proper one
        return Promise.resolve({
          data: items.slice(initialIndexParam, lastIndex),
          total: totalItems,
          from: initialIndexParam,
          to: lastIndex
        });
      }
      var limitToRequest = calculateLimit({
        totalItems: totalItems,
        fetchItemLimit: fetchItemLimit
      });
      var pageToRequest = getPageToRequest({
        maxRequestedPage: requestedPage,
        lastIndex: lastIndex,
        pageSize: pageSize,
        limitToRequest: limitToRequest
      });
      if (totalItems === 0 || items.length - limitToRequest < lastIndex) {
        // We should check if request/fetch is needed based on previous requests
        if (pageToRequest === requestedPage && requestedPage > maxReturnedPage) {
          // A previous request to the same page was done before, return mock
          var extraItems = lastIndex - items.length;
          if (extraItems > 0) {
            // we need $extraItems extra items
            var slicedItems = items.slice(initialIndexParam, items.length - 1);
            for (var index = items.length - 1; index < lastIndex; index += 1) {
              slicedItems.push({
                id: "test".concat(index),
                url: ''
              });
            }
            return Promise.resolve({
              data: slicedItems,
              total: totalItems,
              from: initialIndexParam,
              to: items.length - 1
            });
          }

          // no need for extra item required
          return Promise.resolve({
            data: items.slice(initialIndexParam, items.length - 1),
            total: totalItems,
            from: initialIndexParam,
            to: items.length - 1
          });
        }
        requestedPage += 1;
        // Internal getData get from fetcher from page $pageToRequest
        // eslint-disable-next-line newline-before-return
        return ds.getData(pageToRequest, pageSize, lastIndex).then( /*#__PURE__*/function () {
          var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(result) {
            return _regeneratorRuntime().wrap(function _callee3$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  maxReturnedPage += 1;
                  addItems(result);
                  _context3.next = 4;
                  return ds.getTotalNumber();
                case 4:
                  totalItems = _context3.sent;
                  return _context3.abrupt("return", {
                    data: items.slice(latestInitialIndex, latestLastIndex),
                    total: totalItems,
                    from: latestInitialIndex,
                    to: latestLastIndex,
                    emptyDSResponse: result.data.length === 0
                  });
                case 6:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          }));
          return function (_x3) {
            return _ref5.apply(this, arguments);
          };
        }());
      }

      // Data from previously stored
      return Promise.resolve({
        data: items.slice(initialIndexParam, lastIndex),
        total: totalItems,
        from: initialIndexParam,
        to: lastIndex
      });
    };
    return {
      items: items,
      getData: getData,
      getTotalItems: getTotalItems
    };
  }, [ds, fetchItemLimit, pageSize]);
  var calculateDots = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var dots, totalItems, items, dsData, slides, i, _items$i, _items$i2;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          dots = [];
          if (!ds) {
            _context4.next = 11;
            break;
          }
          _context4.next = 4;
          return internalDS.getTotalItems();
        case 4:
          totalItems = _context4.sent;
          _context4.next = 7;
          return internalDS.getData(0, totalItems);
        case 7:
          dsData = _context4.sent;
          items = dsData.data;
          _context4.next = 13;
          break;
        case 11:
          totalItems = data.length;
          items = data;
        case 13:
          slides = getTotalSlides(vertical ? width : height, vertical ? itemWidth : itemHeight, spacing, totalItems);
          for (i = 0; i < slides; i += 1) {
            dots.push( /*#__PURE__*/React.createElement("div", {
              key: (_items$i = items[i]) === null || _items$i === void 0 ? void 0 : _items$i[keyProperty],
              className: state.id === ((_items$i2 = items[i]) === null || _items$i2 === void 0 ? void 0 : _items$i2[keyProperty]) ? componentTheme.active : ''
            }));
          }
          setState(function (value) {
            return _objectSpread(_objectSpread({}, value), {}, {
              dots: dots
            });
          });
        case 16:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  })), [data, ds, internalDS, height, itemHeight, itemWidth, spacing, vertical, width, state.id]);
  React.useEffect(function () {
    if (showDots) {
      calculateDots();
    }
  }, [calculateDots, showDots]);

  /**
   * react to data source changing
   */
  // ref is used to avoid callback changing each time value changes
  var initialPositionRef = React.useRef();
  initialPositionRef.current = initialPosition;
  var itemsRef = React.useRef();
  itemsRef.current = state.items;
  var recoverFocus = React.useRef('');
  React.useEffect(function () {
    var _itemsRef$current;
    var currentFocus = focusManager.getCurrentFocus();

    // grid currently has focus while data is changing.

    if ((_itemsRef$current = itemsRef.current) !== null && _itemsRef$current !== void 0 && _itemsRef$current.some(function (item) {
      return item.nav.id === currentFocus;
    })) {
      // track the current focused item to try to recover focus to same item after items have rendered again
      recoverFocus.current = currentFocus;
    }
    var ff = {
      // if there is no recoverFocus then forwardFocus is reset so it will default to the first visible item after items have rendered
      forwardFocus: recoverFocus.current || ''
    };

    // if itemsRef has no value then grid has not yet been rendered.

    if (!itemsRef.current && !recoverFocus.current) {
      // don't reset forward focus if grid has not been rendered before
      ff = undefined;
    }
    setState(function (value) {
      var _recoverFocus$current;
      return _objectSpread(_objectSpread(_objectSpread({}, value), ff), {}, {
        id: (_recoverFocus$current = recoverFocus.current) === null || _recoverFocus$current === void 0 ? void 0 : _recoverFocus$current[keyProperty],
        // new instance to represent the data change
        instance: increaseInstance(),
        // reset focused flag until item gains focus. this will prioritize forwardFocus instead of last focus
        focused: false
      }, updatePosition(value, initialPositionRef.current, true));
    });
  }, [
  // this effect should only trigger when data source changes
  data, ds, keyProperty, updatePosition]);
  var automaticFocus = React.useRef(false);
  var edgeRef = React.useRef();
  edgeRef.current = state.edge;
  var forwardFocusRef = React.useRef();
  forwardFocusRef.current = state.forwardFocus;
  var focusedRef = React.useRef();
  focusedRef.current = state.focused;
  /**
   * update what to focus when items have changed
   */
  React.useEffect(function () {
    var _state$items;
    var focusItem;
    var adjustPosition = false;

    // recover focus when grid item was focused during data change
    if (recoverFocus.current && (_state$items = state.items) !== null && _state$items !== void 0 && _state$items.length) {
      var _state$items2, _state$items2$find;
      focusItem = (_state$items2 = state.items) === null || _state$items2 === void 0 ? void 0 : (_state$items2$find = _state$items2.find) === null || _state$items2$find === void 0 ? void 0 : _state$items2$find.call(_state$items2, function (item) {
        return item.nav.id === recoverFocus.current;
      });
      // if recoverFocus was already focused,
      // then a new focus event is not triggered,
      // so need to adjust position here
      adjustPosition = true;
    } else {
      var _state$items3, _state$items3$find;
      focusItem = (_state$items3 = state.items) === null || _state$items3 === void 0 ? void 0 : (_state$items3$find = _state$items3.find) === null || _state$items3$find === void 0 ? void 0 : _state$items3$find.call(_state$items3, function (item) {
        return item.nav.id === forwardFocusRef.current;
      });
    }
    var newPosition;

    // ensure that item is visible

    if (focusItem && adjustPosition) {
      var dim = vertical ? 'y' : 'x';
      var lengthSize = vertical ? height : width;
      var itemSize = vertical ? itemHeight : itemWidth;
      var offset = edgeRef.current.head ? headPadding : headPeek;
      if (focusItem[dim] < offset - positionRef.current) {
        newPosition = offset - focusItem[dim];
      }
      offset = edgeRef.current.tail ? tailPadding : tailPeek;
      if (newPosition === undefined && focusItem[dim] + itemSize > lengthSize - offset - positionRef.current) {
        newPosition = lengthSize - offset - (focusItem[dim] + itemSize);
      }
    }

    // default to first item that is visible when no other item is found
    if (!focusItem) {
      var _state$items4, _state$items4$find;
      var _dim = vertical ? 'y' : 'x';
      var _offset = edgeRef.current.head ? headPadding : headPeek;
      focusItem = (_state$items4 = state.items) === null || _state$items4 === void 0 ? void 0 : (_state$items4$find = _state$items4.find) === null || _state$items4$find === void 0 ? void 0 : _state$items4$find.call(_state$items4, function (item) {
        return item[_dim] >= _offset - positionRef.current;
      });
    }
    if (focusItem) {
      /**
       * there is a recoverFocus set, meaning that the grid had focus
       * while data changed, and grid should maintain focus.
       * if the last focused item is no longer included in the new
       * items, then focus must be placed on a new item so focus is
       * maintained.
       */
      if (recoverFocus.current && recoverFocus.current !== focusItem.nav.id) {
        automaticFocus.current = true;
        // new focus will trigger position adjustment and state update if needed.
        focusManager.changeFocus(focusItem.nav.id);
      } else {
        /**
         * focus will not change, manually adjust state and position as needed
         */
        setState(function (value) {
          return _objectSpread(_objectSpread(_objectSpread({}, value), updatePosition(value, newPosition)), {}, {
            id: focusItem.data[keyProperty],
            forwardFocus: focusItem.nav.id,
            edge: {
              head: focusItem.head === true || value.edge.head,
              tail: focusItem.tail === true || value.edge.tail
            }
          });
        });
      }
      recoverFocus.current = '';
    }
  }, [
  // important that only items change trigger this effect, so the focus item is only changed when the items change.
  state.items,
  // rest of dependencies are static values that should not change after grid create and not trigger this effect.
  parentNav.id, vertical, headPadding, headPeek, tailPadding, tailPeek, updatePosition, itemWidth, itemHeight, height, width, keyProperty]);
  var parentId = React.useRef();
  parentId.current = parentNav.id;
  var initialStateRef = React.useRef();
  initialStateRef.current = initialState;
  var initialInstance = initialState === null || initialState === void 0 ? void 0 : initialState.instance;
  /**
   * allow controlling grid by updating initialState.instance
   */

  React.useEffect(function () {
    var _initialStateRef$curr, _initialStateRef$curr2;
    var newPosition;
    var newId;
    if (!Number.isNaN(Number((_initialStateRef$curr = initialStateRef.current) === null || _initialStateRef$curr === void 0 ? void 0 : _initialStateRef$curr.position)) && positionRef.current !== initialStateRef.current.position) {
      newPosition = initialStateRef.current.position;
    }
    if (((_initialStateRef$curr2 = initialStateRef.current) === null || _initialStateRef$curr2 === void 0 ? void 0 : _initialStateRef$curr2.id) !== undefined) {
      var _initialStateRef$curr3;
      var id = getItemNavId((_initialStateRef$curr3 = initialStateRef.current) === null || _initialStateRef$curr3 === void 0 ? void 0 : _initialStateRef$curr3.position, parentId.current);
      if (forwardFocusRef.current !== id) {
        newId = id;
      }
    }
    if (newPosition !== undefined || newId !== undefined) {
      setState(function (value) {
        var newState = {};
        if (newPosition !== undefined) {
          newState = updatePosition(value, newPosition);
        }
        if (newId !== undefined) {
          newState.forwardFocus = newId;
        }
        return _objectSpread(_objectSpread(_objectSpread({}, value), newState), {}, {
          // new instance to trigger item refresh
          instance: increaseInstance()
        });
      });
    }
  }, [
  // this effect should only be triggered by initialState.instance
  initialInstance, updatePosition]);

  /**
   * refocus opposite edge item after looping
   */
  React.useEffect(function () {
    if (reFocus.current !== 0 && shiftPanel.current) {
      var _state$items5, _state$items6;
      // refocus first item and items have been updated to contain first item
      if (reFocus.current === 1 && ((_state$items5 = state.items) === null || _state$items5 === void 0 ? void 0 : _state$items5[0].head) === true) {
        focusManager.changeFocus(state.items[0].nav.id);
        reFocus.current = 0;
      }
      // refocus last item and items have been updated to contain last item
      else if (reFocus.current === -1 && ((_state$items6 = state.items) === null || _state$items6 === void 0 ? void 0 : _state$items6[state.items.length - 1].tail) === true) {
        focusManager.changeFocus(state.items[state.items.length - 1].nav.id);
        reFocus.current = 0;
      }
    } else if (!forwardFocusRef.current && (initialStateRef === null || initialStateRef === void 0 ? void 0 : initialStateRef.current.position) !== undefined) {
      // it must happen when component is using dataSource only. When the items are got for
      // the first time, the focus is changed automatically
      forwardFocusRef.current = initialStateRef.current.position;
    }
  }, [state.items]);

  /**
   * React to focus change and update position to display the focused item in view
   */
  // ref is used to avoid callback changing each time value changes
  var onItemFocus = React.useCallback(function (item) {
    var x = item.x,
      y = item.y,
      head = item.head,
      tail = item.tail,
      nav = item.nav;
    recoverFocus.current = '';
    var newPosition;
    var newEdge;
    var newState = stateRef.current;
    var itemPosition = vertical ? y : x;
    var itemSize = vertical ? itemHeight : itemWidth;
    var lengthSize = vertical ? height : width;
    var headOffset = head === true ? headPadding : headPeek;
    var tailOffset = tail === true ? tailPadding : tailPeek;
    if (itemPosition + itemSize + tailOffset > -positionRef.current + lengthSize) {
      newPosition = -(itemPosition + itemSize + tailOffset - lengthSize);
      if (tail === true && edgeRef.current.tail !== true) {
        newEdge = {
          tail: true,
          head: false
        };
      }
      // shifting away from head, so no longer at head position
      else if (edgeRef.current.head === true) {
        newEdge = {
          tail: false,
          head: false
        };
      }
    } else if (itemPosition - headOffset < -positionRef.current) {
      newPosition = -itemPosition + headOffset;
      if (head === true && edgeRef.current.head !== true) {
        newEdge = {
          tail: false,
          head: true
        };
      }
      // shifting away from tail, so no longer at tail position
      else if (edgeRef.current.tail === true) {
        newEdge = {
          tail: false,
          head: false
        };
      }
    }
    if (newPosition !== undefined || !focusedRef.current || forwardFocusRef.current !== nav.id) {
      // setState callback is not instant, so a local value is used so the flag can be reset
      var autoFocus = automaticFocus.current;
      automaticFocus.current = false;
      var now = new Date().getTime();
      // throttle when focus changes too often to avoid going out of sync with animation and to improve performance and responsiveness
      var throttle = now - newState.lastUpdate < 100;
      newState = _objectSpread({
        lastUpdate: now,
        throttle: throttle,
        // don't consider focused if focus was triggered by automatic focus
        focused: autoFocus !== true,
        id: item.data[keyProperty],
        forwardFocus: nav.id,
        edge: _objectSpread(_objectSpread({}, newState.edge), newEdge)
      }, updatePosition(newState, newPosition, throttle));
      setState(function (value) {
        return _objectSpread(_objectSpread({}, value), newState);
      });
    }
    onFocus === null || onFocus === void 0 ? void 0 : onFocus({
      data: item.data,
      state: {
        position: newState.position,
        id: item.data[keyProperty]
      }
    });
  }, [onFocus, updatePosition, itemHeight, itemWidth, vertical, height, width, tailPadding, headPadding, headPeek, tailPeek, keyProperty]);
  var sourceRef = React.useRef();
  sourceRef.current = {
    ds: ds,
    data: data,
    internalDS: internalDS
  };
  var dataInstance = React.useRef(0);
  var spreadMin = state.spread[0];
  var spreadMax = state.spread[1];
  /**
   * Loading data for the current position
   */

  React.useEffect(function () {
    var _sourceRef$current$da;
    dataInstance.current += 1;
    var instance = dataInstance.current;
    var _calculateItems = calculateItems({
        spread: [spreadMin, spreadMax],
        width: width,
        buffer: buffer,
        vertical: vertical,
        height: height,
        itemWidth: itemWidth,
        spacing: spacing,
        itemHeight: itemHeight
      }),
      firstIndex = _calculateItems.firstIndex,
      lastIndex = _calculateItems.lastIndex;
    if ((_sourceRef$current$da = sourceRef.current.data) !== null && _sourceRef$current$da !== void 0 && _sourceRef$current$da.length) {
      // invalid data index at position
      if (firstIndex >= sourceRef.current.data.length && positionRef.current !== headPadding) {
        // reset position to trigger new render
        setState(function (value) {
          return _objectSpread(_objectSpread({}, value), updatePosition(value, headPadding, true));
        });
      } else {
        var items = getStructuredItems({
          rtl: rtl,
          parent: parentId.current,
          firstIndex: firstIndex,
          total: sourceRef.current.data.length,
          items: sourceRef.current.data.slice(firstIndex, lastIndex + 1),
          keyProperty: keyProperty,
          vertical: vertical,
          itemHeight: itemHeight,
          itemWidth: itemWidth,
          spacing: spacing,
          width: width,
          height: height
        });
        setState(function (value) {
          return _objectSpread(_objectSpread({}, value), {}, {
            items: items
          });
        });
      }
    } else if (sourceRef.current.ds) {
      if (instance === dataInstance.current) {
        sourceRef.current.ds.hasData().then(function (initialData) {
          sourceRef.current.ds.isPaginationAllowed().then(function (isPaginationAllowed) {
            if (!initialData || isPaginationAllowed) {
              sourceRef.current.internalDS.getData(firstIndex, lastIndex).then(function (result) {
                var _result$data;
                // data change effect has not been triggered since data load started, this data is correct
                // if (instance === dataInstance.current) {
                // no data at position
                if (!(result !== null && result !== void 0 && (_result$data = result.data) !== null && _result$data !== void 0 && _result$data.length) && positionRef.current !== headPadding) {
                  // reset position to trigger new render
                  setState(function (value) {
                    return _objectSpread(_objectSpread({}, value), updatePosition(value, headPadding, true));
                  });
                } else {
                  var _initialStateRef$curr4;
                  var _items = getStructuredItems({
                    rtl: rtl,
                    parent: parentId.current,
                    firstIndex: result.from,
                    total: result.total,
                    items: result.data,
                    keyProperty: keyProperty,
                    vertical: vertical,
                    itemHeight: itemHeight,
                    itemWidth: itemWidth,
                    spacing: spacing,
                    width: width,
                    height: height
                  });
                  if (!forwardFocusRef.current && ((_initialStateRef$curr4 = initialStateRef.current) === null || _initialStateRef$curr4 === void 0 ? void 0 : _initialStateRef$curr4.id) === undefined) {
                    var _items$;
                    // we need to set the initial state
                    // only for the firstime because forwardFocusRef.current is undefined
                    // for other iterations, focus must follow the items nav strategy
                    initialStateRef.current.id = _items === null || _items === void 0 ? void 0 : (_items$ = _items[0]) === null || _items$ === void 0 ? void 0 : _items$.nav.id;
                  }
                  if (result.emptyDSResponse && _items.length) {
                    // If response from DS is empty we have reached end of data and need to avoid scroll issues
                    // by navigating back to the latest item
                    focusManager.changeFocus(_items[_items.length - 1].nav.id);
                  } else {
                    setState(function (value) {
                      return _objectSpread(_objectSpread({}, value), {}, {
                        items: _items
                      });
                    });
                  }
                }
              });
            }
          });
        });
      }
    }
  }, [
  /**
   * spread array is not of interest,
   * the values inside the array are.
   * using separate variables to
   * avoid this effect potentially
   * triggering because the array
   * changed but the values are same.
   */
  spreadMin, spreadMax,
  /**
   * instance is updated when data or ds changes.
   * state and state position needs to update when
   * data or ds changes, so data and ds are not
   * used as dependencies here so they don't
   * trigger this effect. instead instance will
   * trigger this effect after data or ds has
   * updated and instance value has changed.
   */
  // state.instance,

  /**
   * static/stable values that are not expected
   * to change after grid has been created,
   * and should not trigger this effect after
   * grid is created, but the values are needed
   * inside the effect, so they are dependencies
   * to appease eslint and static analysis
   * during compile.
   */
  updatePosition, rtl, keyProperty, vertical, headPadding, itemHeight, itemWidth, spacing, width, height, buffer, data, ds]);

  /**
   * Place shift panel to reflect position
   */
  var shiftStyle = {
    position: 'absolute'
  };
  {
    var x;
    var y;
    if (vertical) {
      x = crossOffset;
      if (rtl) {
        x = width - crossOffset;
      }
      y = state.position;
    } else {
      x = state.position;
      if (rtl && !vertical) {
        x = width - state.position;
      }
      y = crossOffset;
    }
    if (animatedProp) {
      shiftStyle.transform = "translate3d(".concat(x, ", ").concat(y, ", 0)");
      shiftStyle.left = 0;
      shiftStyle.top = 0;
    } else {
      shiftStyle.left = x;
      shiftStyle.top = y;
    }
  }

  /**
   * peek blocks are used to cover the peek area.
   * peek blocks can be styled to display fading of content if needed.
   * peek blocks will also avoid triggering grid shift with pointer focus in browser.
   */
  var headPeekBlocker = React.useMemo(function () {
    if (vertical) {
      return {
        width: width,
        height: headPeek - spacing,
        left: crossOffset
      };
    }
    return {
      width: headPeek - spacing,
      height: height,
      top: crossOffset
    };
  }, [width, headPeek, crossOffset, vertical, height, spacing]);
  var tailPeekBlocker = React.useMemo(function () {
    if (vertical) {
      return {
        width: width,
        height: tailPeek - spacing,
        left: crossOffset
      };
    }
    return {
      width: tailPeek - spacing,
      height: height,
      top: crossOffset
    };
  }, [width, tailPeek, crossOffset, vertical, height, spacing]);

  /**
   * Cull items when animation ends
   */
  React.useEffect(function () {
    var cleanup;
    var panel = shiftPanel.current;
    if (animatedProp && panel) {
      var end = function end(event) {
        if (event.target === panel && event.propertyName === 'transform') {
          // Animation has stopped, reset spread, items outside grid will be culled
          setState(function (value) {
            return _objectSpread(_objectSpread({}, value), updatePosition(value, value.position, true));
          });
        }
      };
      panel.addEventListener('transitionend', end);
      cleanup = function cleanup() {
        panel.removeEventListener('transitionend', end);
      };
    }
    return cleanup;
  },
  // ref is used as a dependency. changing ref alone will not trigger a rerender, but once this is available the listener should be added
  [animatedProp, shiftPanel.current]);
  var gridTheme = React.useMemo(function () {
    return _objectSpread(_objectSpread({}, componentTheme), theme);
  }, [theme]);

  /**
   * Method to calculate the internal navigation of the grid pages
   */
  var page = React.useCallback(function (direction) {
    var triggerPosition = positionRef.current;
    var spanCount = calculateSpanCount(vertical ? width : height, vertical ? itemWidth : itemHeight, spacing);
    var lengthSize = vertical ? height : width;
    var itemSizeWithSpacing = (vertical ? itemHeight : itemWidth) + spacing;
    var triggerShift = function triggerShift(count) {
      var tailPos = lengthSize + spacing - Math.ceil(count / spanCount) * itemSizeWithSpacing - tailPadding;
      var pos = Math.max(tailPos, positionRef.current - itemSizeWithSpacing * Math.max(1, Math.floor(lengthSize / itemSizeWithSpacing) - 1));
      setState(function (value) {
        return _objectSpread(_objectSpread(_objectSpread({}, value), updatePosition(value, pos)), {}, {
          forwardFocus: loop ? null : value.forwardFocus,
          // no forwardFocus for loop gird
          edge: {
            head: false,
            tail: pos === tailPos
          }
        });
      });
    };
    if (direction === -1) {
      if (!stateRef.current.edge.head) {
        var pos = Math.min(headPadding, positionRef.current + itemSizeWithSpacing * Math.max(1, Math.floor(lengthSize / itemSizeWithSpacing) - 1));
        setState(function (value) {
          return _objectSpread(_objectSpread(_objectSpread({}, value), updatePosition(value, pos)), {}, {
            forwardFocus: loop ? null : value.forwardFocus,
            // no forwardFocus for loop gird
            edge: {
              tail: false,
              head: pos === headPadding
            }
          });
        });
      } else if (loop) {
        var loopTail = function loopTail(count) {
          var tailPos = lengthSize + spacing - Math.floor(count / spanCount) * itemSizeWithSpacing - tailPadding;
          setState(function (value) {
            return _objectSpread(_objectSpread(_objectSpread({}, value), updatePosition(value, tailPos)), {}, {
              edge: {
                tail: true,
                head: false
              }
            });
          });
        };
        if (ds) {
          ds.getTotalNumber().then(function (count) {
            // position has not changed during asynchronous operation
            if (triggerPosition === positionRef.current) {
              loopTail(count);
            }
          });
        } else if (data) {
          loopTail(data.length);
        }
      }
    } else if (direction === 1) {
      if (!stateRef.current.edge.tail) {
        if (ds) {
          ds.getTotalNumber().then(function (count) {
            // position has not changed during asynchronous operation
            if (triggerPosition === positionRef.current) {
              triggerShift(count);
            }
          });
        } else if (data) {
          triggerShift(data.length);
        }
      } else if (loop) {
        setState(function (value) {
          return _objectSpread(_objectSpread(_objectSpread({}, value), updatePosition(value, headPadding)), {}, {
            edge: {
              tail: false,
              head: true
            }
          });
        });
      }
    }
  }, [vertical, width, height, itemWidth, itemHeight, spacing, tailPadding, updatePosition, loop, headPadding, ds, data]);
  React.useImperativeHandle(ref, function () {
    return {
      page: page
    };
  }, [page]);
  var last = lastState.current;
  lastState.current = state;
  if (last.id && state.id) {
    if (onChange && (last.id !== state.id || last.position !== state.position)) {
      onChange(lastState.current);
    }
  }

  /**
   * animate grid shift when
   * not throttling and
   * focused once or when looping
   */
  var animated = animatedProp && !state.throttle && (state.focused || reFocus.current !== 0);
  var gridNav = React.useMemo(function () {
    var value = _objectSpread(_objectSpread({}, parentNav), {}, {
      /**
       * last focus can cause issues when grid items
       * have been removed and last focus is referring
       * to an item that is no longer rendered.
       * instead forwardFocus is updated to always
       * reflect what should gain focus.
       */
      useLastFocus: false,
      forwardFocus: state.forwardFocus
    }, internalNav ? {
      internal: internalNav
    } : undefined);

    /*
     * only allow navigating away from grid at edge
     */
    if (!state.edge.head) {
      if (rtl) {
        value[vertical ? 'nextup' : 'nextleft'] = undefined;
      } else {
        value[vertical ? 'nextup' : 'nextright'] = undefined;
      }
    }
    if (!state.edge.tail) {
      if (rtl) {
        value[vertical ? 'nextdown' : 'nextleft'] = undefined;
      } else {
        value[vertical ? 'nextdown' : 'nextright'] = undefined;
      }
    }
    return value;
  }, [parentNav, state.forwardFocus, state.edge.head, state.edge.tail, internalNav, rtl, vertical]);
  var isArrowEnabled = function isArrowEnabled(position) {
    return arrows === false ? false : loop || !state.edge[position];
  };
  var isHeadArrowEnable = isArrowEnabled('head');
  var isTailArrowEnable = isArrowEnabled('tail');

  // const prevSpecificStyles = React.useMemo(
  //   () =>
  //     vertical
  //       ? { top: '10px', left: `${width / 2 - 50}px` }
  //       : { left: '10px', top: `${height / 2 - 50}px` },
  //   [width, height]
  // );

  // const nextSpecificStyles = React.useMemo(
  //   () =>
  //     vertical
  //       ? { bottom: '-10px', left: `${width / 2 - 50}px` }
  //       : { right: '10px', top: `${height / 2 - 50}px` },
  //   [width, height]
  // );

  var DefaultNextIcon = vertical ? DefaultArrowDownIcon : DefaultArrowRightIcon;
  var ArrowNextIcon = arrowsIcons !== null && arrowsIcons !== void 0 && arrowsIcons.nextButton ? arrowsIcons === null || arrowsIcons === void 0 ? void 0 : arrowsIcons.nextButton : DefaultNextIcon;
  var DefaultPrevIcon = vertical ? DefaultArrowUpIcon : DefaultArrowLeftIcon;
  var ArrowPrevIcon = arrowsIcons !== null && arrowsIcons !== void 0 && arrowsIcons.prevButton ? arrowsIcons === null || arrowsIcons === void 0 ? void 0 : arrowsIcons.prevButton : DefaultPrevIcon;
  if (!((_state$items7 = state.items) !== null && _state$items7 !== void 0 && _state$items7.length)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(FocusDiv, _extends({
    className: classnames(componentTheme.grid, theme === null || theme === void 0 ? void 0 : theme.grid, className, gridTheme[vertical ? 'vertical' : 'horizontal'], (_classnames = {}, _defineProperty(_classnames, gridTheme.animatedGrid, animated), _defineProperty(_classnames, componentTheme.tail, state.edge.tail), _defineProperty(_classnames, componentTheme.head, state.edge.head), _defineProperty(_classnames, theme === null || theme === void 0 ? void 0 : theme.tail, state.edge.tail), _defineProperty(_classnames, theme === null || theme === void 0 ? void 0 : theme.head, state.edge.head), _classnames)),
    dir: dir,
    nav: gridNav,
    style: _objectSpread({
      width: width,
      height: height
    }, style)
  }, props), /*#__PURE__*/React.createElement("div", {
    className: gridTheme.shiftPanelContainer
  }, /*#__PURE__*/React.createElement("div", {
    ref: shiftPanel,
    className: gridTheme.shiftPanel,
    style: shiftStyle
  }, (_state$items8 = state.items) !== null && _state$items8 !== void 0 && _state$items8.length ? renderItems({
    rtl: rtl,
    dir: dir,
    itemWidth: itemWidth,
    itemHeight: itemHeight,
    DisplayComponent: DisplayComponent,
    displayComponentProps: displayComponentProps,
    onFocus: onItemFocus,
    items: state.items,
    onClick: onClick && onItemClick
  }) : null)), showDots && !!((_state$items9 = state.items) !== null && _state$items9 !== void 0 && _state$items9.length) && /*#__PURE__*/React.createElement("div", {
    className: componentTheme.heroDots,
    dir: dir
  }, state.dots), /*#__PURE__*/React.createElement("div", {
    className: classnames(componentTheme.headBlock, theme === null || theme === void 0 ? void 0 : theme.headBlock),
    style: headPeekBlocker
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(componentTheme.tailBlock, theme === null || theme === void 0 ? void 0 : theme.tailBlock),
    style: tailPeekBlocker
  }), arrows && /*#__PURE__*/React.createElement(React.Fragment, null, (rtl && isTailArrowEnable || !rtl && isHeadArrowEnable) && /*#__PURE__*/React.createElement(FocusDivButton, {
    className: "".concat((arrowsTheme === null || arrowsTheme === void 0 ? void 0 : arrowsTheme.prevButton) || (componentTheme === null || componentTheme === void 0 ? void 0 : componentTheme.prevButton), " ").concat(vertical ? (arrowsTheme === null || arrowsTheme === void 0 ? void 0 : arrowsTheme.prevButtonVertical) || (componentTheme === null || componentTheme === void 0 ? void 0 : componentTheme.prevButtonVertical) : (arrowsTheme === null || arrowsTheme === void 0 ? void 0 : arrowsTheme.prevButtonHorizontal) || (componentTheme === null || componentTheme === void 0 ? void 0 : componentTheme.prevButtonHorizontal)),
    nav: {
      parent: parentNav.id,
      id: "".concat(parentNav.id, "-head-arrow")
    },
    onClick: function onClick() {
      return rtl ? page(1) : page(-1);
    },
    theme: arrowsTheme || componentTheme
  }, /*#__PURE__*/React.createElement(ArrowPrevIcon, {
    style: {
      display: 'inline-block'
    }
  })), (rtl && isHeadArrowEnable || !rtl && isTailArrowEnable) && /*#__PURE__*/React.createElement(FocusDivButton, {
    className: "".concat((arrowsTheme === null || arrowsTheme === void 0 ? void 0 : arrowsTheme.nextButton) || (componentTheme === null || componentTheme === void 0 ? void 0 : componentTheme.nextButton), " ").concat(vertical ? (arrowsTheme === null || arrowsTheme === void 0 ? void 0 : arrowsTheme.nextButtonVertical) || (componentTheme === null || componentTheme === void 0 ? void 0 : componentTheme.nextButtonVertical) : (arrowsTheme === null || arrowsTheme === void 0 ? void 0 : arrowsTheme.nextButtonHorizontal) || (componentTheme === null || componentTheme === void 0 ? void 0 : componentTheme.nextButtonHorizontal)),
    nav: {
      parent: parentNav.id,
      id: "".concat(parentNav.id, "-tail-arrow")
    },
    onClick: function onClick() {
      return rtl ? page(-1) : page(1);
    },
    theme: arrowsTheme || componentTheme
  }, /*#__PURE__*/React.createElement(ArrowNextIcon, {
    style: {
      display: 'inline-block'
    }
  }))));
};
var FocusContentGridForward = /*#__PURE__*/React.forwardRef(FocusContentGrid);
FocusContentGridForward.propTypes = {
  /**
   * When alignGrid is used, values for padding and peek
   * will be calculated so grid items are always placed
   * in the same positions when the grid is shifted.
   * set this to false to use the peek and padding values
   * provided.
   */
  alignGrid: PropTypes.bool,
  /**
   * when this flag is true it is expected that the grid is using css
   * transitions to animate shifting.
   * theme.animatedGrid class is added when animations should be
   * applied, and the grid will expect transitionend event to be
   * triggered when transition has completed.
   */
  animated: PropTypes.bool,
  /**
   * Whether arrows are enabled or not
   */
  arrows: PropTypes.bool,
  /**
   * Custom Icons for the prev and Next Arrow buttons
   */
  arrowsIcons: PropTypes.shape({
    nextButton: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    prevButton: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
  }),
  /**
   * CSS Styles for the arrows, with button and buttonFocused to pass to the FocusDivButton
   */
  arrowsTheme: PropTypes.object,
  /**
   * Buffer is the number of extra item spans to render outside the grid.
   * If there is no padding then this is needed so there is always
   * at least one item available that can gain focus
   */
  buffer: PropTypes.number,
  className: PropTypes.string,
  /** offset along the direction of the grid where to start render items */
  crossOffset: PropTypes.number,
  /** Static data array */
  data: PropTypes.array,
  /** directionallity from locale */
  dir: PropTypes.oneOf(['rtl', 'ltr']),
  /**
   * Component used to render each item.
   * IMPORTANT: the component needs to use the containerStyle prop and assign
   * to the parent element of the DisplayComponent in order to work properly on a space
   */
  DisplayComponent: PropTypes.func.isRequired,
  /** arbitrary props object to include when rendering each item defined in DisplayComponent */
  displayComponentProps: PropTypes.object,
  /** Datasource fetcher object. Should include getData, getTotalItems, isPaginationAllowed and hasData */
  ds: PropTypes.shape({
    /** Number of items to fetch. Default is 20 */
    /**
     * Number of items defined as limit before doing another request to prefetch data
     * (ie: we fetch 20 items, define fetchItemLimit to 10, so when the finalIndex
     * is greater than the lenght - limit we do another request)
     */
    fetchItemLimit: PropTypes.number,
    getData: PropTypes.func.isRequired,
    getTotalNumber: PropTypes.func.isRequired,
    hasData: PropTypes.func.isRequired,
    isPaginationAllowed: PropTypes.func.isRequired,
    pageSize: PropTypes.number
  }),
  /**
   * Padding values are used to position items away from grid edge.
   * Additional items will still render inside the padding area, to provide context when navigating.
   */
  headPadding: PropTypes.number,
  /**
   * Peek values represent the size of the area where items are rendered when grid has been shifted.
   * If headPadding is 32 and headPeek is 64, this means that the first item will be 32
   */
  headPeek: PropTypes.number,
  /** Used for internal calculations but may not reflect the actual size of the element. */
  height: PropTypes.number,
  /**
   * whether orientation should be horizontal (default is vertical) or not
   */
  horizontal: PropTypes.bool,
  /** initialState.position will decide what items are rendered */
  initialState: PropTypes.shape({
    id: PropTypes.string,
    position: PropTypes.number
  }),
  /**
   * Height of single items
   */
  itemHeight: PropTypes.number.isRequired,
  /**
   * Width of single items
   */
  itemWidth: PropTypes.number.isRequired,
  /**
   * property name of data object that represents a unique data item. often "id" for data.id.
   * used for key in react loop to indicate to react what the item in the loop is.
   */
  keyProperty: PropTypes.string.isRequired,
  /**
   * jump to opposing edge when trying to navigate beyond edge
   */
  loop: PropTypes.bool,
  /** nav object from @accedo/vdkweb-navigation */
  nav: PropTypes.object,
  /** will trigger when grid position or focus changes */
  onChange: PropTypes.func,
  /** onClick is added to each grid item. Will be executed when the user interact with the item. */
  onClick: PropTypes.func,
  /** onClick is added to each grid item, Will be executed when the user place the focus in the item. */
  onFocus: PropTypes.func,
  /**
   * repeat items, endless grid
   * reserved for future use
   */
  repeat: PropTypes.bool,
  rtl: PropTypes.bool,
  /**
   * whether dots needs to be shown or not
   */
  showDots: PropTypes.bool,
  /** Distance between each rendered item (in pixels) */
  spacing: PropTypes.number,
  /** Arbitrary css style object to apply to dom element */
  style: PropTypes.object,
  /**
   * Padding values are used to position items away from grid edge.
   * Additional items will still render inside the padding area, to provide context when navigating.
   *
   * Use this prop if you want to change from which item to scroll. This is defined in Pixels for both carousels and Grids
   */
  tailPadding: PropTypes.number,
  /**
   * Peek values represent the size of the area where items are rendered when grid has been shifted.
   * If headPadding is 32 and headPeek is 64, this means that the first item will be 32.
   */
  tailPeek: PropTypes.number,
  /** theme object from css module */
  theme: PropTypes.object,
  /**
   * whether orientation should be vertical (default) or not
   */
  vertical: PropTypes.bool,
  /**
   * width is not the width of the container element, but the width inside the container where items can render.
   * width and height are used for internal calculations but may not reflect the actual size of the element.
   * width and height also needs to be defined in theme/style to set the correct size of the grid.
   */
  width: PropTypes.number.isRequired
};
FocusContentGrid.propTypes = FocusContentGridForward.propTypes;
export default FocusContentGridForward;
/* eslint-enable require-await */